import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import Spinner from '../common/Spinner';
import { useAdminNotificationsStore } from '../../stores/useAdminNotificationsStore';

const AdminNotificationDropdown = ({ onClose }) => {
  const notifications = useAdminNotificationsStore((s) => s.notifications);
  const unreadCount = useAdminNotificationsStore((s) => s.unreadCount);
  const isLoading = useAdminNotificationsStore((s) => s.isLoading);
  const fetchNotifications = useAdminNotificationsStore((s) => s.fetchNotifications);
  const markAllAsRead = useAdminNotificationsStore((s) => s.markAllAsRead);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  return (
    <div className="absolute right-0 top-full mt-2 w-96 bg-white dark:bg-slate-900 rounded-xl shadow-2xl border border-gray-200 dark:border-slate-700 z-50 overflow-hidden">
      <div className="px-4 py-3 border-b border-gray-100 dark:border-slate-700 flex items-center justify-between">
        <h3 className="text-sm font-bold text-gray-800 dark:text-gray-100">Alertas financieras</h3>
        <button
          onClick={() => {
            markAllAsRead();
            if (onClose) onClose();
          }}
          className="text-xs font-semibold text-blue-600 hover:underline"
          disabled={unreadCount === 0}
        >
          Marcar todo
        </button>
      </div>

      <div className="max-h-96 overflow-y-auto">
        {isLoading ? (
          <div className="flex justify-center p-4"><Spinner size="sm" /></div>
        ) : notifications.length === 0 ? (
          <div className="p-8 text-center text-gray-500 text-sm">No hay notificaciones recientes.</div>
        ) : (
          <ul className="divide-y divide-gray-100 dark:divide-slate-800">
            {notifications.map((notification) => (
              <li key={notification._id} className={`px-4 py-3 ${notification.isRead ? '' : 'bg-amber-50/40'}`}>
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm font-semibold text-gray-800 dark:text-gray-100">
                      {notification.message}
                    </p>
                    {notification.metadata?.referenceId && (
                      <p className="text-xs text-gray-500">Ref: {notification.metadata.referenceId}</p>
                    )}
                    {notification.stackTrace && (
                      <pre className="mt-2 text-[11px] text-rose-600 whitespace-pre-wrap">{notification.stackTrace}</pre>
                    )}
                  </div>
                  <span className="text-[11px] text-gray-400 whitespace-nowrap">
                    {notification.createdAt
                      ? format(new Date(notification.createdAt), 'd MMM, HH:mm', { locale: es })
                      : 'Reciente'}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default AdminNotificationDropdown;
